import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { NgClass } from '@angular/common';
import { ResponsiveComponent } from '@nx-superprep/shared'
import { UserService } from '@nx-superprep/backend/firebase'
import { DateOnly, log } from '@nx-superprep/utils'
import { catchError, of, takeUntil } from 'rxjs'

type DateElement = {
  date: DateOnly,
}
@Component({
  selector: 'pop-ui-date-picker',
  standalone: true,
  imports: [NgClass],
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent extends ResponsiveComponent implements OnInit, OnDestroy {

  @Input() tileCount = 5
  @Input() activeDate: DateOnly = new DateOnly()
  @Output() activeDateChange = new EventEmitter<DateOnly>()

  elements: DateElement[] = this.getDaysArray(this.activeDate)

  private _activeElement!: DateElement

  isActive(item: DateElement) {
    return !!this._activeElement?.date && item.date.isSame(this._activeElement.date)
  }

  onSelect(item: DateElement) {
    this._activeElement = item
    this.activeDateChange.emit(this._activeElement.date)
  }

  getDateCount() {
    return 5 // Math.min(7, Math.max(5, Math.floor(window.innerWidth / (16 + (this.isWeb ? 220 : 58)))))
  }

  getDayNumber(d: DateOnly) {
    return DateOnly.pad(d.getDate(), 2)
  }

  getDayName(d: DateOnly) {
    return d.weekdayShort() //this.isWeb ? d.weekdaysShort() : d.weekdaysMin()
  }

  getDaysArray(t: DateOnly = new DateOnly()) {
    const c = Math.floor(this.getDateCount() / 2)
    const a = []
    const e = t.add(+c, 'day')
    for(let d = t.add(-c, 'day'); d.isSameOrBefore(e); d = d.add(1, 'day')) {
      a.push({date: d })
    }
    return a
  }

  getActive(elements: DateElement[]) {
    return elements.find(e => this.isActive(e)) ?? elements[Math.floor(elements.length / 2)]
  }

  onReset(date?: DateOnly): void {
    const firstElement = this.elements[0]
    this.elements = this.getDaysArray(date)
    const isSameDates = this.elements[0].date.isSame(firstElement.date)
    const selectedElement = this.getActive(this.elements)
    const newElement = date ? this.elements.find(e => e.date.isSame(date)) : selectedElement
    if (!this._activeElement || !isSameDates || date) {
      this.onSelect(newElement ?? selectedElement)
    }
    this.activeDate = date ?? new DateOnly()
  }

  private observeUserDataChanges(): void {
    this.userService.userData
      .pipe(
        takeUntil(this.onDestroy),
        catchError(error => {log.error(error); return of(null) })
      )
      .subscribe((user) => { if (user) { this.onReset()}})
  }

  override ngOnInit() {
    super.ngOnInit()
    this.onReset()
    this.observeUserDataChanges()
  }

  readonly userService = inject(UserService)

  constructor() {
    super()
    super.rootClassName = 'date-picker-root-class-name'
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  //override onFocus(event: FocusEvent): void { this.onReset() }
  override onVisibilityChange(event: Event): void { if (document.visibilityState === 'visible') { this.onReset(new DateOnly()) } }
  /* eslint-enable @typescript-eslint/no-unused-vars */
}
